<script setup>
import {reactive, ref} from "vue";
import {validateNumber} from "../../store/form_validate"
import {useSystem} from "../../store/system"
import {useUser} from "../../store/user"

const userStore = useUser()
const systemStore = useSystem()
//获取提现方式列表  也是用户的对应钱包地址
systemStore.withdrawalMethodListApi()

const ruleFormRef = ref(null)
const ruleForm = reactive({
  payment_id: '',
  wallet_address: '',
  payment_pwd: ''
})
const rules = reactive({
  payment_id: [
    {required: true, message: 'Please choose payment!', trigger: 'blur'},
  ],
  wallet_address: [
    {required: true, type: 'string', message: 'Invalid address!', trigger: 'blur'},
  ],
  payment_pwd: [
    {required: true, type: 'string', message: 'Invalid password!', trigger: 'blur'},
  ]
})
const submitForm = async (formEl) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      userStore.setWithdrawAddressApi({
        address: ruleForm.wallet_address,
        payment_id: ruleForm.payment_id,
        password: ruleForm.payment_pwd
      })
    } else {
      console.log('error submit!', fields)
    }
  })
  formEl.resetFields()
}
const resetForm = (formEl) => {
  if (!formEl) return
  formEl.resetFields()
}

const currentPayment = ref(null)
const withdrawChange = (value) => {
  let payment = systemStore.getWithdrawList.find(item => item.id == value)
  currentPayment.value = payment
  ruleForm.wallet_address = payment.address
}


const tableData = []

</script>

<template>
  <el-row>
    <el-col :span="24">
      <div class="card-bg">
        <div class="tw-p-4 tw-bottom-line tw-font-bold tw-text-[18px]">Withdraw Settings</div>
        <div class="tw-p-4 tw-flex tw-justify-center">
          <el-form
              ref="ruleFormRef"
              style="max-width: 500px"
              :model="ruleForm"
              :rules="rules"
              label-width="auto"
              label-position="top"
              class="tw-w-full"
              size="large"
              status-icon
          >
            <el-form-item label="Withdraw Network" prop="payment_id">
              <el-select v-model="ruleForm.payment_id" placeholder="Withdraw Network" @change="withdrawChange">
                <el-option
                    class="!tw-h-[45px]"
                    v-for="(item, index) in systemStore.getWithdrawList"
                    :label="item.name"
                    :key="index"
                    :value="item.id"
                >
                  <div class="tw-h-full tw-flex tw-justify-start tw-items-center">
                    <el-avatar :size="30" :src="item.image" />
                    <div class="tw-ml-2">{{item.name}}</div>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Wallet Address" prop="wallet_address">
              <el-input v-model="ruleForm.wallet_address" />
            </el-form-item>

            <el-form-item label="Payment Password" prop="payment_pwd">
              <el-input type="password" v-model="ruleForm.payment_pwd" />
              <span class="feature__text tw-text-[14px]">Default password: {{systemStore.website.default_pay_password}}</span>
            </el-form-item>

            <el-form-item>
              <div class="tw-mt-[1rem] tw-flex tw-justify-end tw-w-full tw-space-x-5">
                <el-button @click="resetForm(ruleFormRef)">Clear</el-button>
                <el-button type="primary" @click="submitForm(ruleFormRef)">
                  Submit
                </el-button>
              </div>
            </el-form-item>
          </el-form>

        </div>
      </div>
    </el-col>
    <el-col :span="24">
      <div class="card-bg tw-mt-8">
        <div class="tw-p-4 tw-bottom-line tw-font-bold tw-text-[18px]">Wallets</div>
        <div class="tw-p-4">
          <el-table
              :data="systemStore.getWithdrawList"
              class="tw-w-full"
          >
            <el-table-column prop="name" label="Symbol">
              <template #default="{row, column, $index}">
                <div class="tw-h-full tw-flex tw-justify-start tw-items-center">
                  <el-avatar class="tw-flex-none" v-if="row.image" :size="30" :src="row.image" />
                  <div class="tw-ml-2">{{row.name}}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="Address"/>
            <template #empty>
              <el-empty :image-size="120"></el-empty>
            </template>
          </el-table>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<style lang="scss">
.el-form-item__label{
  color: $p-text-color !important;
}

.el-table {
  background-color: unset !important;
  color: #FFFFFF;
  border-color: $p-border-color !important;

  // 每行tr的底部线条
  td.el-table__cell, .is-leaf{
    border-bottom: 2px solid $p-border-color !important;
  }

  //解决最后一排边框线
  .el-table__inner-wrapper:before{
    background-color: unset !important;
  }

  .el-table__header-wrapper {
    tr {
      // 表头背景色
      background-color: unset;

      th {
        color: $p-text-color;
        background-color: rgba(0, 0, 0, 0);
      }
    }

  }

  .el-table__body-wrapper {
    tr {
      // 表格内容背景色
      background-color: unset;
      color: $p-text-color;

      &:hover>td {
        //修改(hover)悬浮背景色
        background-color: $p-table-row-active-color !important;
      }
    }
  }
}
</style>
